// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TermsOfUse_wrapper__29aYS","link":"TermsOfUse_link__2aq1u"};